import { ArrowRightIcon as PhosphorArrowRightIcon } from "@phosphor-icons/react/dist/ssr/ArrowRight";

import { createAppIcon } from "@/components/createAppIcon";

export const ArrowForwardIcon = /* @__PURE__ */ createAppIcon(PhosphorArrowRightIcon);
